import React from 'react';
import styles from './styles.module.css';
import Image from 'next/image';
import { Button } from 'common/new-button';
import { Icon } from 'common/icon';
import profileImage from '../../../../assets/images/aboutus/image.svg';
import { TeamMember } from 'components/template/about-us/teamData';

export const Card = ({ member }: { member: TeamMember }) => {
  const subject = 'Inquiry from RTPCheck Website';
  const body = `Hello ${member.name},`;

  const handleEmailClick = () => {
    const mailtoLink = `mailto:${member.email ?? ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };
  return (
    <div className={styles.cardContainer}>
      <div className={styles.mainCard}>
        <div className={styles.cardRow}>
          <div className={styles.imageContainer}>
            <Image
              src={member.imageUrl || profileImage}
              alt="card-profile-image"
              width={120}
              height={120}
              className={styles.profileImage}
            />
          </div>

          <div className={styles.profile}>
            <div className={styles.name}>{member.name}</div>
            <div className={styles.role}>{member.position}</div>
          </div>
        </div>
        <div className={styles.textContainer}>
          <p className={styles.descriptionText}>{member.description}</p>
          <Button
            className={styles.emailButton}
            text={'Write an email'}
            icon={<Icon.EmailSecond />}
            onClick={handleEmailClick}
          />
        </div>
      </div>
    </div>
  );
};
